/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import EmpTrainingPresenter from "./EmpTrainingPresenter";
import DTOEmptraining from "./DTOEmptraining";
import { trainingServices } from "../../../../api/services/trainingServices";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

const EmpTrainingController = () => {
  const { t, i18n } = useTranslation();
  const [trainingData, settrainingData] = useState([]);
  const [refresh, setRefresh] = useState(false);

  function callBackFunc(data: any) {
    settrainingData(data);
  }
  const getUpdateAcceptStatus = async (status: any, id: any) => {
    const response: any = await trainingServices.updateTrainingStatus(
      status,
      id
    );

    if (response.response == "success" && response?.data?.status == 2) {
      setRefresh(true);

      toast.success(t("Accepted Successfully"));
    } else if (response.response == "success" && response?.data?.status == 4) {
      setRefresh(true);

      toast.success(t("Training Cancelled"));
    }
  };

  return (
    <>
      <DTOEmptraining setEmptrainingDatas={callBackFunc} refresh={refresh} />
      <EmpTrainingPresenter
        trainingData={trainingData}
        setAcceptStatus={getUpdateAcceptStatus}
        i18n={i18n}
        trans={t}
      />
    </>
  );
};
export default EmpTrainingController;
